import { setCareerSource } from './reducer';
export var setCareerSourceAction = function (sourceNode, sourcePatch, sourcePort, position, edge) {
    return function (dispatch) {
        dispatch(setCareerSource({ sourceNode: sourceNode, sourcePatch: sourcePatch, sourcePort: sourcePort, position: position, edge: edge }));
    };
};
// export const clearCareerSourceAction = (dispatch) => {
//   dispatch(clearCareerSource());
// };
